import React from "react";
function H1(props){
    return(
    <>
    <h1 className={props.name}>{props.title}</h1>
    </>);
}
export default H1;